import { AssetLoader } from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import { gsap } from "gsap";
import { Texture, spine } from "pixi.js";

import { ColorSet, log } from "../utils/AbstractConsole";

let assetsLoader: AssetLoader;
export const setAssetsLoader = (gameAssetsLoader: AssetLoader) => (assetsLoader = gameAssetsLoader);

export class AbstractSpine extends spine.Spine {
    protected currentTrack: spine.core.TrackEntry;
    protected animationsMap: Map<string, { duration: number }> = new Map();
    protected currentAnimationName: string = ``;

    constructor(spineName: string) {
        super(assetsLoader.getSpineAsset(spineName));

        this.name = spineName.replace(`spine/`, ``).replace(`.json`, ``);

        this.init();
    }

    protected init(): void {
        this.scale.set(0.5);

        for (let i = 0; i < this.spineData.animations.length; i++) {
            const animation = this.spineData.animations[i];
            this.animationsMap.set(animation.name, { duration: animation.duration });
        }
    }

    public replaceRefTextureName(textureName: string): void {
        this.hackTextureBySlotName(`ref`, Texture.from(textureName));
        this.update(0);
    }

    public replaceRefTexture(texture: any): void {
        this.hackTextureBySlotName(`ref`, texture);
        this.update(0);
    }

    public getAnimationDuration(animationName: string): number {
        if (!this.animationsMap.has(animationName)) {
            // console(`no animation `, animationName, ` mapped to ` + this.name + `!`);
        }

        return this.animationsMap.get(animationName)?.duration!;
    }

    public getSpineTween(
        animationName: string,
        loop: boolean = false,
        onStart: Function | null = null,
        onUpdate: Function | null = null,
        onComplete: Function | null = null
    ): gsap.core.Tween {
        if (!this.animationsMap.has(animationName)) {
            log(
                `Animation doesn't exists. Please check the animation name: ${animationName}`,
                ColorSet.DEFAULT,
                this.animationsMap
            );
        }

        let duration = this.animationsMap.get(animationName)?.duration;
        if (duration !== undefined && duration === 0) {
            duration = 0.01;
        }

        let spineTween = gsap.to(this, {
            duration: duration,
            ease: `none`,
            onStart: () => {
                onStart !== null && onStart();

                this.currentTrack = this.state.setAnimation(0, animationName, false);

                this.currentTrack.timeScale = 0;
                this.currentTrack.trackTime = 0;

                this.currentAnimationName = animationName;
            },
            onUpdate: () => {
                onUpdate !== null && onUpdate();

                if (this.currentTrack) {
                    this.currentTrack.trackTime = spineTween.time();
                } else {
                    // log(`current track undefined ${this.name}->${animationName}`);
                    this.currentTrack = this.state.setAnimation(0, animationName, false);
                    if (spineTween) {
                        this.currentTrack.trackTime = spineTween.time();
                    }
                }
            },
            onComplete: () => {
                if (loop && this.currentAnimationName === animationName) {
                    this.state.setAnimation(0, animationName, loop);
                }

                onComplete !== null && onComplete();
            },
        });

        return spineTween;
    }

    public setSkinByName(skinName: string) {
        // @ts-ignore
        this.skeleton.setSkin(null);
        this.skeleton.setSkinByName(skinName);
    }

    // setSkinByName('lighter');

    public reset(): void {
        this.alpha = 1;

        this.state?.clearTracks();
        this.skeleton?.setBonesToSetupPose();
        this.skeleton?.setToSetupPose();
        this.state?.setEmptyAnimations(0);
        this.state !== null && this?.update(0);

        this.currentAnimationName = ``;
        gsap.killTweensOf(this);
    }
}
